import React, { useState } from 'react';
import block from 'bem-cn';
import SVGInline from 'react-svg-inline';
import { withRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';

import SVG from 'components/SVG';

import HeaderDropdown from './HeaderDropdown';
import LanguageDropdownSelector from 'components/LanguageDropdownSelector';

import bellSVG from 'shared/img/bell.svg';
import telegramSVG from 'shared/img/telegram.svg';
import userSVG from '../img/user.svg';
import arrowSVG from '../img/arrow.svg';

import NotifiesView from './NotifiesView';

import './Header.scss';

const Header = () => {
  const b = block('header');
  const [headerDropdownVisible, setHeaderDropdownVisible] = useState(false);
  const [isNotifiesOpen, setIsNotifiesOpen] = useState(false);
  const [openedNotify, setNotify] = useState(null);

  const auth = useSelector(state => state.auth);
  const locale = useSelector(state => state.locale.locale);
  const { telegram } = useSelector(state => state.userSettings.social_network_settings);

  const handleCloseNotifies = () => {
    setNotify(null);
    setIsNotifiesOpen(false);
  };

  const handleOpenNotifies = () => {
    setIsNotifiesOpen(!isNotifiesOpen);
  };

  return (
    <div className={b({ open: headerDropdownVisible })}>
      <a href={telegram} className={b('telegram')} target="_blank">
        <SVG containerClassName={b('telegram-icon')} svgProps={{ svg: telegramSVG }} />
      </a>
      <div className={b('wrapper-notifies')}>
        <div className={b('notifies-wrapper')} onClick={handleOpenNotifies}>
          {auth.notifications?.length > 0 && <div className={b('notifies-count')}>{auth.notifications?.length}</div>}
          <SVGInline className={b('bell').toString()} svg={bellSVG} />
        </div>
        {isNotifiesOpen && (
          <div className={b('notifies-container')}>
            <NotifiesView openedNotify={openedNotify} setNotify={setNotify} closeFunction={handleCloseNotifies} />
          </div>
        )}
      </div>
      <div className={b('language-selector')}>
        <LanguageDropdownSelector isHeader />
      </div>
      <div className={b('user-balance')}>
        <div className={b('user-balance-info')}>
          <span className={b('user-balance-title')}>{locale.balance}</span>
          <span className={b('user-info-login')}>{`${auth.balance} ${auth.currency}`}</span>
        </div>
      </div>
      <div onClick={() => setHeaderDropdownVisible(!headerDropdownVisible)} className={b('user')}>
        <div className={b('user-info')}>
          <span className={b('user-info-id')}>{`${locale.id}: ${auth.id}`}</span>
          <span className={b('user-info-login')}>{`${auth.username}`}</span>
        </div>
        <SVGInline svg={userSVG} className={b('user-img').toString()} />
        <SVGInline svg={arrowSVG} className={b('user-arrow').toString()} />
      </div>
      {headerDropdownVisible && <HeaderDropdown changeOpen={setHeaderDropdownVisible} />}
    </div>
  );
};

export default withRouter(Header);
